import React from "react";
import { FormattedMessage } from "react-intl";
import PropertyWithTitle from "./PropertyWithTitle";

interface ServiceClassProps {
  id?: string;
}

export function ServiceClass({ id }: ServiceClassProps) {
  if (!id) {
    return null;
  }
  return (
    <div>
      <FormattedMessage id={`shared.service.${id}`} />
    </div>
  );
}

export function ServiceClassWithTitle({ id }: ServiceClassProps) {
  if (!id) {
    return null;
  }
  return (
    <PropertyWithTitle isList title="shared.service-class">
      <ServiceClass id={id} />
    </PropertyWithTitle>
  );
}

export default ServiceClass;
